var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29249 6.70998C9.68249 6.31998 10.3125 6.31998 10.7025 6.70998L15.2925 11.3C15.6825 11.69 15.6825 12.32 15.2925 12.71L10.7025 17.3C10.3125 17.69 9.68249 17.69 9.29249 17.3C8.90249 16.91 8.90249 16.28 9.29249 15.89L13.1725 12L9.29249 8.11998C8.90249 7.72998 8.91249 7.08998 9.29249 6.70998Z"
  })));
};
export default SvgArrowRight;